import { Routes, Route } from 'react-router-dom';
import CustomCursor from './components/CustomCursor';
import BackToTop from './components/BackToTop';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TechStack from './components/TechStack';
import About from './components/About';
import Skills from './components/Skills';
import Services from './components/Services';
import Experience from './components/Experience';
import Education from './components/Education';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Motion from './components/Motion';

function Home() {
  return (
    <>
      <Hero />
      <TechStack />
      <About />
      <Skills />
      <Services />
      <Experience />
      <Education />
      <Projects />
      <Contact />
      <Footer />
      <Motion />
    </>
  );
}

export default function App() {
  return (
    <div style={{ position: 'relative', width: '100%', background: '#000', overflowX: 'hidden' }}>
      <CustomCursor />
      <BackToTop />
      <Navbar />
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
        </div>
      </div>
    </div>
  );
}
